import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
